import { useDraftConditions } from '@retail/calculus/context';
import { PageLayout } from '@retail/components';
import { Paper } from '@shared/components';
import { DraftAffectedItemsContainer } from '@retail/calculus/containers';
import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router';

export const ApprovalCalculusPage = () => {
  const [searchParams] = useSearchParams();

  const supplierId = searchParams.get('supplierId');

  const { groupedConditions } = useDraftConditions();
  const conditionsForSupplier =
    groupedConditions.find((conditions) => conditions.assortmentOrSupplierId + '' === supplierId)
      ?.conditions ?? [];

  const [selectedConditionIds, selectConditionIds] = useState<number[]>([]);

  const updateConditionIds = useCallback(
    (id: number) =>
      selectConditionIds(
        selectedConditionIds.includes(id)
          ? selectedConditionIds.filter((condId) => condId !== id)
          : [...selectedConditionIds, id]
      ),
    [selectedConditionIds]
  );

  return (
    <PageLayout maxWidth="full" fixedHeight spacing={2}>
      <Paper sx={{ display: 'flex', flexDirection: 'column', p: 0, height: '100%' }}>
        <DraftAffectedItemsContainer
          supplierNumber={Number(supplierId)}
          selectedConditionIds={selectedConditionIds.length ? selectedConditionIds : undefined}
          updateConditionIds={updateConditionIds}
          draftConditions={conditionsForSupplier}
        />
      </Paper>
    </PageLayout>
  );
};
